import React, { useState, useEffect } from 'react';
import { Dialog, IconButton, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AddIcon from '@mui/icons-material/Add';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import getServices from '../../Services/get-service';
import Constant from '../../Constant';

function PaymentMethodModal({ open, handleClose, handleBack, onReviewOrder }) {
  const [selectedMethod, setSelectedMethod] = useState('wallet');
  const [walletBalance, setWalletBalance] = useState(0);
  const [loadingBalance, setLoadingBalance] = useState(false);

  useEffect(() => {
    if (open) {
      setLoadingBalance(true);
      getServices.getWalletBalance().then(res => {
        if (res.data.statusCode === 200 && res.data.data.length > 0) {
          setWalletBalance(res.data.data[0].availableBalance);
        }
        setLoadingBalance(false);
      }).catch(() => setLoadingBalance(false));
    }
  }, [open]);

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: '24px',
          padding: '24px',
          backgroundColor: '#FAFAFB',
          boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)'
        }
      }}
    >
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-3">
          <IconButton onClick={handleBack} size="small">
            <ArrowBackIcon fontSize="small" style={{ color: '#1A1A1B' }} />
          </IconButton>
          <span className="font-bold text-[14px] text-back-color2">Back</span>
        </div>
        <div 
          onClick={handleClose}
          className="w-8 h-8 rounded-full bg-[#1A1A1B] flex items-center justify-center cursor-pointer hover:bg-gray-800"
        >
          <CloseIcon fontSize="small" style={{ color: 'white' }} />
        </div>
      </div>

      <p className="text-[12px] font-bold text-back-color2 mb-4">Payment method</p>

      {/* Wallet Option */}
      <div 
        onClick={() => setSelectedMethod('wallet')}
        className={`bg-white rounded-xl p-4 flex justify-between items-center mb-4 cursor-pointer border ${
          selectedMethod === 'wallet' ? 'border-[#00BC67]' : 'border-gray-100'
        }`}
      >
        <div className="flex items-center gap-4">
          <div className="w-10 h-10 rounded-full bg-[#E6F8F0] flex items-center justify-center">
            <AccountBalanceWalletIcon style={{ color: '#00BC67', fontSize: '20px' }} />
          </div>
          <span className="text-[14px] font-bold text-back-color2">Wallet</span>
        </div>
        <div className="flex items-center gap-3">
          {loadingBalance ? (
            <CircularProgress size={14} style={{ color: '#00BC67' }} />
          ) : (
            <span className="text-[12px] font-bold text-back-color2">NGN {Constant.FormatNumber(walletBalance)}</span>
          )}
          {selectedMethod === 'wallet' 
            ? <RadioButtonCheckedIcon style={{ color: '#00BC67', fontSize: '20px' }} />
            : <RadioButtonUncheckedIcon style={{ color: '#D1D5DB', fontSize: '20px' }} />
          }
        </div>
      </div>

      {/* Card Option */}
      <div 
        onClick={() => setSelectedMethod('card')}
        className={`bg-white rounded-xl p-4 flex justify-between items-center mb-4 cursor-pointer border ${
          selectedMethod === 'card' ? 'border-[#00BC67]' : 'border-gray-100'
        }`}
      >
        <div className="flex items-center gap-4">
          <div className="w-10 h-10 rounded-full bg-[#E6F8F0] flex items-center justify-center">
            <CreditCardIcon style={{ color: '#00BC67', fontSize: '20px' }} />
          </div>
          <span className="text-[14px] font-bold text-back-color2">Card</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-[12px] font-bold text-back-color2">**** 2898</span>
          <div className="flex">
            {/* Simple Mastercard CSS logo replacement */}
            <div className="w-3 h-3 bg-red-500 rounded-full opacity-80 z-10"></div>
            <div className="w-3 h-3 bg-yellow-400 rounded-full opacity-80 -ml-1"></div>
          </div>
          <KeyboardArrowDownIcon style={{ color: '#808285', fontSize: '20px' }} />
        </div>
      </div>

      {/* New Card Button */}
      <div className="bg-white rounded-xl py-3 px-4 flex items-center gap-2 mb-10 w-32 border border-gray-100 cursor-pointer hover:bg-gray-50">
        <span className="text-[12px] font-bold text-[#00BC67]">New card</span>
        <AddIcon style={{ color: '#00BC67', fontSize: '16px' }} />
      </div>

      {/* Info Notice */}
      <div className="bg-[#F9FAFB] border border-gray-100 rounded-xl p-3 flex items-center gap-2 mb-6">
        <InfoOutlinedIcon style={{ color: '#00BC67', fontSize: '16px' }} />
        <span className="text-[10px] text-[#00BC67]">A processing fee of 1.5% will be added at checkout</span>
      </div>

      {/* Review Order Button */}
      <button 
        onClick={onReviewOrder}
        className="w-full bg-primary-color text-white font-bold py-3.5 rounded-xl text-[14px] hover:bg-[#00a359] transition-colors"
      >
        Review Order
      </button>

    </Dialog>
  );
}

export default PaymentMethodModal;
